import { authMiddleware } from "@/middleware";
import { createFileRoute } from "@tanstack/react-router";

import { DashboardLayout } from "@/components";
import OrderPage from "@/pages/orders/Orders";
import { currentUserAtom } from "@/store/login";
import { zodValidator } from "@tanstack/zod-adapter";
import { useAtomValue } from "jotai";
import { z } from "zod";

const SearchSchema = z.object({
	new: z.coerce.boolean().default(false),
});

export type OrdersSearch = z.infer<typeof SearchSchema>;

export const Route = createFileRoute("/_market/orders/")({
	validateSearch: zodValidator(SearchSchema),
	component: () => {
		const userRole = useAtomValue(currentUserAtom)?.user_role;
		const isAdmin = userRole === "ADMIN";

		return (
			<DashboardLayout>
				<OrderPage isAdmin={isAdmin} />
			</DashboardLayout>
		);
	},
	loader: authMiddleware,
});
